import React,{useState} from 'react'
import  {Form,Col,Container,Table,Button} from 'react-bootstrap';
import scale from './hoehn_yahr.json'
import Title from '../../utilities/other/title';
function AnswerField(props){
    const [value,setValue] = useState(props.data!=null?props.data:"")
    const onChange =(event) =>{
        
        setValue(event.target.value)
        props.handler(event)
        
    }
    
   
    return(
            
        <Form.Group as={Col}>
                
                <Form.Control as={"select"} onChange={onChange} name={'symptoms'} value={value} disabled={props.disabled}>
                        {scale.map((s,index) =>(
                            <option key={index} desc={s.stage}>{s.symptoms}</option>))}
                </Form.Control>
            </Form.Group>
    
        )
}
class Hoehn_yahr extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            stage:"0",
            "symptoms":scale[0].symptoms
        }
        this.onChange = this.onChange.bind(this)
    }
    async onChange(event){
        const {name, value,selectedIndex} = event.target
         this.setState((prevState)=>({
            ...prevState,
            [name]: value,
            stage:scale[selectedIndex].stage
        }))
        this.props.handler("hoehn_yahr",{[name]:value,"stage":scale[selectedIndex].stage})
    }
    // componentDidUpdate(prevProps, prevState){
    //     if (prevState!= this.state){
    //         this.props.handler('hoehn_yahr',this.state)
    //     }
    // }
    componentDidMount() {
       if(this.props.data!=null){
           this.setState(this.props.data)
       }
    }

    render() {
      return (
        <Container>
          {/* <h3 style={{textAlign: 'center'}}>Hoehn and Yarh Scale</h3> */}
          <Title>Hoehn and Yahr Scale</Title>
          <Table>
              <thead>
                  <tr>
                      
                      <th>Sign y of symptoms</th>
                      <th>Stage</th>
                  </tr>
              </thead>
              <tbody>
                  <tr>
                      <td><AnswerField disabled={this.props.disabled} handler={this.onChange} data={this.props.data!=null?this.props.data['symptoms']:null}/></td>
                      <td>{this.state.stage}</td>
                  </tr>
              </tbody>
          </Table>
        </Container>
      )
    };
}
Hoehn_yahr.defaultProps = {
    data:null,
    disabled:false
}
export default Hoehn_yahr;